import { BlocksIconClose } from 'blocks-nextjs/blocks-web-components/components/icon/icons/close';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconClose = createComponent({ react: React, tagName: 'cat-icon-close', elementClass: BlocksIconClose });
